import classNames from "classnames";
import React, { PropsWithChildren } from "react";
import styles from "./Grid.module.scss";

interface GridProps {
  tab?: boolean;
}

export const Grid: React.FC<GridProps & PropsWithChildren> = ({
  children,
  tab = false,
}) => {
  const cx = classNames.bind(styles);
  return (
    <>
      {tab ? (
        <div className={cx(styles.Grid, styles.tab)}>{children}</div>
      ) : (
        <div className={styles.Grid}>{children}</div>
      )}
    </>
  );
};
